<div class="container row center-center">
  @if (shouldRenderForReactiveForms) {
    @if (isEditing) {
      <input
        type="text"
        class="container__input item grow"
        [(ngModel)]="value"
        (keyup)="onKeyUp()"
        [id]="inputId"
        appFocusNextInput
        appFilterInput
        [allowNegativeValue]="canAcceptNegativeValues"
        [inputId]="inputId"
        [disabled]="isDisabled"
        (focusout)="onFocusOut()"
        [formControl]="control"
        #editInput
        />
    }
  }
  @if (!shouldRenderForReactiveForms) {
    @if (isEditing) {
      <input
        type="text"
        class="container__input item grow"
        [(ngModel)]="value"
        (keyup)="onKeyUp()"
        [id]="inputId"
        appFocusNextInput
        appFilterInput
        [allowNegativeValue]="canAcceptNegativeValues"
        [inputId]="inputId"
        [disabled]="isDisabled"
        (focusout)="onFocusOut()"
        #editInput
        />
    }
  }
  @if (!isEditing) {
    <input
      type="text"
      class="container__input item grow"
      [(ngModel)]="displayValue"
      (focusin)="onFocusIn()"
      />
  }

  <div class="container__description row justify-flex-end">
    <label>{{ description }}</label>
  </div>
</div>
